"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spas = void 0;
var _renderers = require("./renderers");
const spas = exports.spas = {
  /** @deprecated Please use BasketProvider from libs instead. */
  basketProvider: _renderers.BasketProvider,
  /** @deprecated LogoutConfirmDialog was moved to @ori-appshell/layouts, this will be removed in the next major release */
  logoutConfirmDialog: _renderers.LogoutConfirmDialog,
  /** @deprecated Please use SubscriptionWizard from libs instead */
  subscriptionWizard: _renderers.SubscriptionWizard,
  /** @deprecated UserSessionProvider was moved to @ori-appshell/layouts, this will be removed in the next major release */
  userSessionProvider: _renderers.UserSessionProvider,
  /** @deprecated This is not necessary anymore as notification menu is imported by TopArea. If you are interested in NotificationsMenu component itself then please import it from @ori/notification-menu package */
  notificationMenu: _renderers.NotificationMenu
};
